import { useEffect, useState } from "react";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Button, Skeleton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './style.scss';
import APIService from "../../../services/api.service";
import axios from "axios";
import { CacheService } from "../../../common/services/cache.service";
import environment from "../../../environment/environment";
import { OrderUpdateDialog } from "../../dialogs/Order-Update-Dialog";
import { OrderDownloadDialog } from "../../dialogs/Order-Download-Dialog";
import FileSaver from 'file-saver';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { tokenState } from "../../../atoms/token";
import { useRecoilState } from "recoil";

const Orders = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [showDownloadDialog, setShowDownloadDialog] = useState(false);
  const [row, setRow] = useState(null);
  const [reload, setReload] = useState(false);
  const [orders, setOrders] = useState([]);
  const [token, setToken] = useRecoilState(tokenState);
  const [error, setError] = useState(null);
  const { id } = useParams();  // Access the ID parameter from the URL
  const navigate = useNavigate();

  useEffect(() => {
    getOrders();

    setReload(false);
  }, [reload]);

  const getOrders = () => { 
    const url = `${environment.eticApiUrl}getorders?pageSize=20000`;
    const apiService = new APIService<any>(axios, new CacheService, url, token);

    apiService.getAnyAsync().then((res:any) => {
      console.log('orders', res);
      setOrders(res.data.sort((a, b) => (a.date > b.date) ? -1 : 1));
      if(id) {
        let order = res.data.find(o => o.id === id);
        setRow(order);
        setShowDownloadDialog(true);
        setError(null);

      }
    });
  }

  const downloadBtnClick = (event, rowParams) => { 
    handleRowClick(rowParams, null);
  }

  const handleRowClick = (rowArgs, event) => {
    setError(null);
    setShowDownloadDialog(true);
    setRow(rowArgs.row);
  }

  const handleRowBtnClick = (event, rowParams) => { 
    setShowDialog(true);
    setRow(rowParams.row);
  }

  const handleCloseClick = () => {
    setShowDialog(false);
    setShowDownloadDialog(false);
    setRow(null);
  }

  const handleSaveClick = (form: any, row: any) => {
    let staffId = form?.staffId ? form.staffId : 'Unassigned';
    const url = `${environment.eticApiUrl}updateorder/${row.id}?status=${form.status.toLowerCase()}&staffId=${staffId}`;
    const apiService = new APIService<any>(axios, new CacheService, url, token);

    apiService.getAnyAsync().then((res:any) => {
      console.log('saved order', res);
      getOrders();
    });

    setShowDialog(false);
    setRow(null);
  }

  const formatDate = (date) => { 
    let d = new Date(date);
    return d.toLocaleDateString();
  }
 
  const columns: GridColDef[] = [
    { field: 'id', headerName: 'Id', width: 100 },
    { field: 'custName', headerName: 'Cust. Name', width: 200 },
    { field: 'email', headerName: 'Cust. Email', width: 250 },
    { field: 'staffName', headerName: 'Tic Staff Asgmt', width: 200 },
    { field: 'staffEmail', headerName: 'Staff Email', width: 200 },
    { field: 'status', headerName: 'Status', width: 100 },
    { field: 'lastModifiedDate', headerName: 'Modified', width: 100 },
    { field: 'date', headerName: 'Date Added', width: 100 },
    { field: 'edit', headerName: 'Edit',
      hideSortIcons: true,
      width: 130,
      renderCell: (cellValues) => {
        return (
          <Button
            variant={"contained"} 
            color={"primary"}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              handleRowBtnClick(event, cellValues);
            }}
            // fontawesome icon for edit
            
            startIcon={<FontAwesomeIcon icon={["fas", "edit"]}/>}
          >
            {'Update'}
          </Button>
        );
      }
    },
    { field: 'download', headerName: 'Download',
    hideSortIcons: true,
    width: 150,
    renderCell: (cellValues) => {
      return (
        <Button
          variant={"contained"} 
          color={"primary"}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            downloadBtnClick(event, cellValues);
          }}
          // fontawesome icon for edit
          
          startIcon={<FontAwesomeIcon icon={["fas", "download"]}/>}
        >
          {'Download'}
        </Button>
      );
    }
  },
  ];
  
  return (
    <>
      {showDialog &&
            <OrderUpdateDialog
              row={row}
              handleSaveClick={handleSaveClick}
              handleCloseClick={handleCloseClick}
            />
      }

      {showDownloadDialog &&
            <OrderDownloadDialog
              row={row}
              handleCloseClick={handleCloseClick}

            />
      }

      <h1 className="center">TIC Order Administration</h1>

      <div className="search-results">
        <div className="center" style={{ height: 400, width: '100%' }}>
          <DataGrid
             sx={{ '.MuiDataGrid-columnHeaderTitle': {fontWeight: 'bolder'},
             '.MuiDataGrid-columnHeaderTitleContainer': {borderBottom: 1 },
             '.MuiDataGrid-row': {cursor: 'pointer', borderBottom: 1},
             '.MuiDataGrid-iconButtonContainer': {visibility: 'visible' },
             '.MuiDataGrid-sortIcon': {opacity: 'inherit !important' }
            }}
            rows={orders.map((result, index) => (
              {
                id: result?.id,
                date: formatDate(result?.date),
                staffName: result?.staffName,
                staffEmail: result?.staffEmail,
                email: result?.email,
                custName: result?.firstName + ' ' + result?.lastName,
                status: result?.status,
                userId: result?.userId,
                lastModifiedDate: formatDate(result?.lastModifiedDate),
              }
            )) || []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            pageSizeOptions={[5, 10, 25, 50]}
            onRowClick={handleRowClick}
            disableRowSelectionOnClick
            loading={orders.length === 0}
          />
        </div>
      </div>
    </>
  );
}

export default Orders;